import React from 'react'
import { Form, Modal, Input, Spin, Button } from 'antd'
import Cards from 'react-credit-cards'
import 'react-credit-cards/lib/styles.scss'
import './styles.scss'
import Visa_Master_Discover_Amex from '../../assets/logo/Visa_Master_Discover_Amex.png'

export default Form.create()(
    ({
        title,
        loading,
        on_cancel,
        on_save,
        firstName,
        lastName,
        number,
        expiry,
        cvc,
        focused,
        callback,
        on_focus,
        on_change,
        valid,
        cardPosition, // top (default), left or none
        form,
    }) => {
        const { getFieldDecorator } = form
        let positionClass
        if (cardPosition === 'left') positionClass = 'card-left'
        else if (cardPosition === 'none') positionClass = 'card-none'
        else positionClass = 'card-top'

        return (
            <div className="add-card-form">
                <Spin spinning={loading}>
                    <div className={positionClass}>
                        <Cards
                            number={number}
                            name={`${firstName} ${lastName}`}
                            expiry={expiry || '##/##'}
                            cvc={cvc}
                            focused={focused}
                            callback={callback}
                        />

                        <Form layout="vertical">
                            <Form.Item
                                label="Card Number"
                                className={'user-input'}>
                                {getFieldDecorator('number', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                'Please input correct card number',
                                        },
                                    ],
                                })(
                                    <Input
                                        type="tel"
                                        name="number"
                                        placeholder="Card Number"
                                        onKeyUp={e => on_change(e.target)}
                                        onFocus={e => on_focus(e.target)}
                                    />
                                )}
                            </Form.Item>

                            <div className="foot-content">
                                <Form.Item
                                    label="First Name"
                                    className={'user-input'}>
                                    {getFieldDecorator('firstName', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input your name',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="text"
                                            name="firstName"
                                            placeholder="First Name"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item
                                    label="Last Name"
                                    className={'user-input'}>
                                    {getFieldDecorator('lastName', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input your name',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="text"
                                            name="lastName"
                                            placeholder="Last Name"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>
                            </div>

                            <div className="foot-content">
                                <Form.Item
                                    label="Exp Date (mm/yy)"
                                    className={'user-input'}>
                                    {getFieldDecorator('expiry', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input valid expiry date',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="tel"
                                            name="expiry"
                                            placeholder="Valid Thru"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item label="CVC" className={'user-input'}>
                                    {getFieldDecorator('cvc', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input valid cvc',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="tel"
                                            name="cvc"
                                            placeholder="CVC"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    style={{ width: '100%' }}
                                    disabled={!valid}
                                    onClick={on_save}>
                                    Add Card
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Spin>
            </div>
        )
    }
)
